export const initialState = {
	data: {},
	isLoading: false,
	isLoaded: false,
	errorMessage: undefined
};

export default initialState;
